import { useEffect, useMemo, useState } from 'react';

const useHoverOrOpenShow = ({
  hoverGroupRef,
  open,
}: {
  hoverGroupRef: React.RefObject<HTMLDivElement | null>;
  open: boolean;
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  useEffect(() => {
    const element = hoverGroupRef.current;

    if (element) {
      element.addEventListener('mouseenter', handleMouseEnter);
      element.addEventListener('mouseleave', handleMouseLeave);
    }

    return () => {
      if (element) {
        element.removeEventListener('mouseenter', handleMouseEnter);
        element.removeEventListener('mouseleave', handleMouseLeave);
      }
    };
  }, [hoverGroupRef.current]);

  const shouldShow = useMemo(() => {
    return isHovered || open;
  }, [isHovered, open]);

  return {
    shouldShow,
  };
};

export default useHoverOrOpenShow;
